module.exports = __webpack_public_path__ + "img/papaya_bg-2.8ebbce8a.png";